export default __webpack_public_path__ + "static/media/azerbaijan.cb858067.svg";